export const MERGE_FIELD_ISSUE_CODES = ['EMPTY', 'CONTAINS_WHITESPACE', 'INVALID_SYMBOLS'] as const;

export type MergeFieldIssueCode = (typeof MERGE_FIELD_ISSUE_CODES)[number];

export type MergeFieldIssue = { code: MergeFieldIssueCode; field: string };
